module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/YearlyTotalRow.ejs -->\n<td class="td-nowrap">\n    <span class="name">\n        ';
 if (model.getPayrollItem().get('name') === 'EIS') { 
__p+='\n            Employee EIS\n        ';
 } else if (model.getPayrollItem().get('name') === 'Salary (Gross)') { 
__p+='\n            Salary (Basic)\n        ';
 } else { 
__p+='\n            '+
((__t=( model.getPayrollItem().get('name') ))==null?'':_.escape(__t))+
'\n        ';
 } 
__p+='\n    </span>\n    ';
 if (deletable) { 
__p+='\n        <a class="js-destroy"><i class="fa fa-times"></i></a>\n    ';
 } 
__p+='\n\n    <div class="error error-monthly error-amount\n        error-prevEmploymentMonthly error-prevEmploymentAmount"></div>\n    <div class="error error-monthly error-amount error-prevEmploymentMonthly\n        error-prevEmploymentAmount error-placeholder"></div>\n</td>\n';
 monthly = model.get(current ? 'monthly': 'prevEmploymentMonthly') || [] 
__p+='\n';
 _.each(months, function(month) { 
__p+='\n    ';
 value = monthly[month.index] || 0; 
__p+='\n    <td class="js-col">\n        <div class="form-group">\n            <input class="form-control form-control-invisible js-ext\n                    js-ext-monthly"\n                data-value-type="float"\n                name="monthly-'+
((__t=( month.index ))==null?'':_.escape(__t))+
'"\n                value="'+
((__t=( value.formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n                type="text">\n\n        </div>\n    </td>\n';
 }) 
__p+='\n<td>\n    <div class="form-group">\n        <input class="form-control form-control-invisible js-ext js-ext-amount"\n            name="amount" data-value-type="float"\n            value="'+
((__t=(
                (model.get(current ? 'amount': 'prevEmploymentAmount') || 0)
                    .formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n            type="text" disabled>\n    </div>\n</td>\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/YearlyTotalRow.ejs
// module id = 801
// module chunks = 1